import { numberFormat } from "helper/numberFormat";

export const calculateInstallmentAmount = (item, type) => {
  if (!item?.installmentStatus) return "";
  if (item?.installment?.value) {
    const itemAmount = type === "product" ? item?.totalAmount : item?.amount
    return numberFormat({
      number: +itemAmount / item?.installment?.value,
      decimal: 2,
      style: "currency",
    });
  }
  return "";
};

export const calculateBulkInstallmentAmount = (item, amount = 0) => {
  if (!item?.installmentStatus) return "";
  if (item?.installment?.value) {
    const itemAmount = amount
    return numberFormat({
      number: +itemAmount / item?.installment?.value,
      decimal: 2,
      style: "currency",
    });
  }
  return "";
};